import React, { useEffect, useRef, useState } from "react";
import { FaCaretLeft } from "react-icons/fa";
import { FaCaretRight } from "react-icons/fa";
import { firstDayOfMonth, formatDate, todayDate, translate, verifyHideCountryItems } from "../../../../utils/Common";
import { FaDoorOpen } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import { FaUnlock } from "react-icons/fa";
import { IoCheckmarkCircle } from "react-icons/io5";
import { TiDelete } from "react-icons/ti";
import { LuAlertCircle } from "react-icons/lu";
import { FaHistory } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { LuBox } from "react-icons/lu";
import * as RiIcons from "react-icons/ri";
import { useLocation } from "react-router-dom";

import { usePlatforms } from "../../../../hooks/usePlatforms";
import Spinner from "../../../../components/Spinner";
import "./index.css";
import { useForm } from "react-hook-form";
import LockerDoor from "./LockerDoor";
import { compareDoorPosition } from "../CreatePlatform/doorOrder";
import { verifyAccessViewPermissions } from "../../../../config/permissions";
import { Tooltip } from "@/components/ui/tooltip";
import { ToastContainer, useToast } from "../../../../components/common/Toast";

const SmartLocker = ({ idPlatform, idPlatformNumeric, estatusPlatform, setListMovements, handleFocusMovements, setFilterMovementSelect, actionsPerms }) => {
  const location = useLocation();
  const { toasts, showSuccess, showError, removeToast } = useToast();
  const [doors, setDoors] = useState(null);
  const [column1, setColumn1] = useState([]);
  const [column2, setColumn2] = useState([]);
  // const [column1Sizes, setColumn1Sizes] = useState({});
  // const [column2Sizes, setColumn2Sizes] = useState({});
  const [moduleShowed, setModuleShowed] = useState(0);
  const [modules, setModules] = useState([]);
  const [selectedDoor, setSelectedDoor] = useState([]);
  const [loadingDoors, setLoadingDoors] = useState({});
  const [btnActionIsActive, setBtnActionIsActive] = useState(false);
  const [actionsInProgress, setActionsInProgress] = useState(0);
  const [dateInputIsActive, setDateInputIsActive] = useState(false);
  const [defaultFromDate, setDefaultFromDate] = useState("");
  const [defaultToDate, setDefaultToDate] = useState("");
  const [messageMovements, setMessageMovements] = useState("");
  const [actionSelect, setActionSelect] = useState(null);
  const [activeSearch, setActiveSearch] = useState(false);
  const [showPackageInfo, setshowPackageInfo] = useState(null);
  const [doorAssignments, setDoorAssignments] = useState({});
  // Referencia para almacenar el módulo mostrado
  const moduleShowedRef = useRef(0);

  const { actionInPlatform, getDoorsByPlatform, getDoorCompanyAssignments } = usePlatforms();
  const { register, handleSubmit, errors } = useForm();

  const onSubmitFilterMovement = () => {
    setMessageMovements("");
    handleOptionSelection("movements");
  };

  const modalCustome = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 8,
      }}
    >
      {selectedDoor.map((id) => {
        let statusMessage = "";
        let numberDoor =
          doors
            .filter((objeto) => objeto.boxitDoorId === id)
            .map((obj) => obj.doorNumber)[0] || "-";

        switch (loadingDoors[id]) {
          case 0:
            statusMessage = <Spinner type={1} size={20} />;
            break;
          case 1:
            statusMessage = (
              <IoCheckmarkCircle size={20} color="rgb(74 222 128)" />
            );
            break;
          case 2:
            statusMessage = <TiDelete size={20} color="red" />;
            break;
          default:
            break;
        }

        return (
          <div key={id} style={styles.doorSelected}>
            <div>
              {translate("global.door")}: {numberDoor}{" "}
              <span style={{ color: "white" }}>{statusMessage}</span>
            </div>
          </div>
        );
      })}

      {dateInputIsActive && (
        <>
          <form>
            <div
              className="flex justify-align-center items-center"
              style={{ flexDirection: "row", flexWrap: "wrap", gap: 5 }}
            >
              <div style={styles.doorSelected}>
                <span className="mr-1">
                  {translate("dashboard.accounting.from")}{" "}
                </span>
                <input
                  type="date"
                  name="dateFrom"
                  className="inputDatePlatform"
                  onChange={(e) => setDefaultFromDate(e.target.value)}
                  defaultValue={defaultFromDate}
                  ref={register({ required: "From date is required" })}
                />

              </div>

              <div style={styles.doorSelected}>
                <span className="mr-1">
                  {translate("dashboard.accounting.to")}{" "}
                </span>
                <input
                  type="date"
                  name="endDate"
                  className="inputDatePlatform"
                  onChange={(e) => setDefaultToDate(e.target.value)}
                  defaultValue={defaultToDate}
                  ref={register({ required: "To date is required" })}
                />

              </div>

              <button
                type="button"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 h-8 rounded-md px-3 text-xs"
                style={{ borderRadius: "50px" }}
                onClick={handleSubmit(onSubmitFilterMovement)}
                disabled={activeSearch}
              >
                <FaSearch />
              </button>
              <div className="btn-reset-platforms" onClick={() => resetFilters()}>
                {translate("global.close")}
              </div>
            </div>

          </form>
          {errors.endDate && <span> {errors.endDate.message} !</span>}
          {errors.dateFrom && <span> {errors.dateFrom.message} !</span>}
          {messageMovements}
        </>
      )}

    </div>
  );

  // Acciones del locker view:
  // - Preferir actions BLI por path; lock y unlock comparten el mismo permiso `lock-door`.
  // - Legacy: `lock_doors` o `unlock_doors` habilitan ambos botones.
  const hasAction = (actionCode, legacyCode) =>
    // Nota: este "locker view" hereda permisos del módulo GENERAL
    verifyAccessViewPermissions([actionCode], { path: "/dashboard/platforms/general" }) ||
    (Array.isArray(actionsPerms) && actionsPerms.includes(legacyCode));

  const hasLockDoorAction = () =>
    verifyAccessViewPermissions(['lock-door'], { path: '/dashboard/platforms/general' }) ||
    (Array.isArray(actionsPerms) &&
      (actionsPerms.includes('lock_doors')));

  const buttonsActionsData = [
    {
      id: "open",
      label: translate("global.open"),
      icon: <FaDoorOpen />,
      actionCode: "open-door",
      legacyCode: "open_door_remote",
    },
    {
      id: "lock",
      label: translate("global.lock"),
      icon: <FaLock />,
      actionCode: "lock-door",
      legacyCode: "lock_doors",
    },
    {
      id: "unlock",
      label: translate("global.unlock"),
      icon: <FaUnlock />,
      actionCode: "lock-door",
      legacyCode: "unlock_doors",
    },
    {
      id: "movements",
      label: translate("global.movements"),
      icon: <FaHistory />,
      actionCode: "view-movements",
      legacyCode: "view_movements_doors",
    },
  ];

  const buttonsActions = buttonsActionsData.map((item, index) => {
    // Verificación si el estatusPlatform es distinto de "ONLINE"
    if (estatusPlatform !== "ONLINE" && item.id !== "movements") {
      return null; // Si no está en "ONLINE" y el botón no es "movements", no se renderiza
    }

    // Condición de opacidad según las restricciones definidas
    const opacityValidate =
      item.id === "movements" && selectedDoor?.length !== 1
        ? 0.5
        : btnActionIsActive > 0
          ? 1
          : 0.5;

    // Manejador del click en cada botón
    const onClickHandler = () => {
      if (selectedDoor?.length > 1) setDateInputIsActive(false);

      if (opacityValidate === 1 && item.id !== "movements") {
        handleOptionSelection(item.id);
      }

      if (item.id === "movements" && selectedDoor?.length === 1) {
        handleOptionSelection(item.id);
        setDateInputIsActive(true);
      }

      setActionSelect(item.id);
    };

    // Renderizado del botón si el usuario tiene permisos
    const actionAllowed =
      item.id === 'lock' || item.id === 'unlock'
        ? hasLockDoorAction()
        : hasAction(item.actionCode, item.legacyCode);
    const disabled = opacityValidate !== 1;
    return actionAllowed && (
      <button
        type="button"
        key={`action-` + item.id}
        disabled={disabled}
        aria-pressed={actionSelect === item.id}
        data-active={actionSelect === item.id ? "true" : undefined}
        className="locker-action"
        onClick={onClickHandler}
      >
        <span className="locker-action-icon">{item.icon}</span>
        <span>{item.label}</span>
      </button>
    );
  });


  const legendData = [
    { label: translate("global.availables"), color: "available" },
    { label: translate("global.actived"), color: "actived" },
    { label: translate("global.reserved"), color: "reserved" },
    { label: translate("global.inactive"), color: "inactive" },
    { label: translate("global.Expired"), color: "expired" },
    { label: translate("global.occupied"), color: "occupied" },
  ];

  /* Colour swatches only: six labelled chips took more room than the cabinet
     they explain. The name rides on a tooltip instead of the native `title`,
     which waits about a second before it appears — long enough that the legend
     read as unexplained dots. Radix shows it in ~200ms and portals it out, so
     the cabinet's own overflow cannot clip it. `tabIndex` makes each swatch
     reachable by keyboard, which is the only way a tooltip-only control is
     usable without a pointer. */
  const legends = legendData.map((item, index) => (
    <Tooltip key={index} label={item.label} side="top" delayDuration={120}>
      <span
        tabIndex={0}
        role="img"
        aria-label={item.label}
        className="locker-legend-dot"
        style={{ background: styles.colorsProperties[item.color] }}
      />
    </Tooltip>
  ));

  const btnsNavigator = {
    back: modules?.length > 1 && moduleShowedRef.current > 0,
    next: modules?.length > 1 && moduleShowedRef.current < modules.length - 1,
  };

  const handleSelectDoor = (door) => {
    setshowPackageInfo(null)
    if (selectedDoor?.length >= 1) setDateInputIsActive(false);
    if (selectedDoor?.length > 0) {
      if (selectedDoor?.includes(door)) {
        let newSelectedDoor = selectedDoor.filter((item) => item !== door);
        setSelectedDoor(newSelectedDoor);
        if (newSelectedDoor.length === 0) setBtnActionIsActive(false);
        return;
      }
      if (actionSelect === "movements") {
        setLoadingDoors({});
        setDateInputIsActive(true);
        setSelectedDoor([door]);
      } else {
        setDateInputIsActive(false);
        setSelectedDoor([...selectedDoor, door]);
      }
    } else {
      setSelectedDoor([door]);
      setBtnActionIsActive(true);
    }
  };

  // El botón vive dentro del popover, que a su vez está dentro de la puerta, así
  // que sin `stopPropagation` el click llegaba al `onClick` de la puerta y lo que
  // pasaba era que se seleccionaba la puerta en vez de copiarse el valor.
  // `navigator.clipboard` además sólo existe en contexto seguro (HTTPS o
  // localhost): servido por IP en la red local es `undefined` y la llamada
  // reventaba en silencio, de ahí el respaldo con `execCommand`. Mismo patrón que
  // el copiar de la búsqueda de paquetes.
  const handleCopyText = async (event, item) => {
    event.stopPropagation();
    const value = item ?? "";
    if (!value) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(String(value));
      } else {
        const tempInput = document.createElement("input");
        tempInput.value = String(value);
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }
      showSuccess(translate("global.copied"), 3000);
    } catch (e) {
      showError(translate("global.errorCopy"), 3000);
    }
  };

  const renderValidateInfoPack = (pkg) => (
    <div>
      <div className="package-info-section">
        <abbr title="attribute">{translate("global.numPackage")}</abbr>:
        <div className="package-info-content">
          <span>
            <LuBox className="mr-1" />
            {pkg.packageNumber ?? ""}
          </span>
          <button
            type="button"
            onClick={(e) => handleCopyText(e, pkg.packageNumber)}
            className="bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 rounded-md p-1"
          >
            <RiIcons.RiFileCopyFill size={14} />
          </button>
        </div>
      </div>
  
      <div className="package-info-section">
        <abbr title="attribute">ID {translate("global.Package")}</abbr>:
        <div className="package-info-content">
          <span>{pkg.packageId ?? ""}</span>
          <button
            type="button"
            onClick={(e) => handleCopyText(e, pkg.packageId)}
            className="bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 rounded-md p-1"
          >
            <RiIcons.RiFileCopyFill size={14} />
          </button>
        </div>
      </div>
    </div>
  );
  
  const renderDoors = (doors) => {
    return doors.map((item, index) => {
      return <LockerDoor
        key={index}
        index={index}
        column1={column1}
        column2={column2}
        item={item}
        selectedDoor={selectedDoor}
        showPackageInfo={showPackageInfo}
        setshowPackageInfo={setshowPackageInfo}
        activeSearch={activeSearch}
        onLockerClick={handleSelectDoor}
        renderValidateInfoPack={renderValidateInfoPack} 
        styles={styles}
        doorAssignments={doorAssignments}
      />;
    });
  };

  const calculateModuleQuantity = (doorsArray) => {
    const moduleSet = new Set();

    doorsArray.forEach((door) => {
      if (door.boxitModuleId) {
        moduleSet.add(door.boxitModuleId);
      }
    });
    return Array.from(moduleSet);
  };

  const handleDoorsChange = (modDoors) => {
    const column1 = modDoors.filter((door) => door.columnModule === 1);
    setColumn1(column1);
    const column2 = modDoors.filter((door) => door.columnModule === 2);
    setColumn2(column2);
  };

  const handleModuleChange = (type) => {
    const modShowed = type ? moduleShowedRef.current + 1 : moduleShowedRef.current - 1;
    const modDoors = doors.filter(
      (door) => door?.boxitModuleId === modules[modShowed]
    );
    setModuleShowed(modShowed);
    moduleShowedRef.current = modShowed;
    handleDoorsChange(modDoors);
  };

  const handleActionDoors = (id, action) => {
    const abortController = new AbortController();
    try {
      const handleResponse = async () => {

        let numberDoor = doors
          .filter((objeto) => objeto.boxitDoorId === id)
          .map((obj) => obj.doorNumber)[0] || "-";

        const filterSelect = {
          doorId: id,
          actionId: action,
          dateFrom: defaultFromDate,
          dateTo: defaultToDate,
          numDoor: numberDoor
        };

        setActionsInProgress((prev) => prev + 1);

        setLoadingDoors((prevLoadingDoors) => ({
          ...prevLoadingDoors,
          [id]: 0,
        })); // status loading

        const response = await actionInPlatform(filterSelect);
        setActiveSearch(false)

        if (response?.code === 200) {
          setLoadingDoors((prevLoadingDoors) => ({ ...prevLoadingDoors, [id]: 1 })); // status success

          if (action === "movements") {
            if (response?.code === 200) {
              setListMovements(response.payload);
              setFilterMovementSelect(filterSelect)
              handleFocusMovements();
            } else {
              setFilterMovementSelect(null)
              setListMovements([]);
            }

          }

        } else if (response?.code === 404) {
          setLoadingDoors((prevLoadingDoors) => ({ ...prevLoadingDoors, [id]: 1 })); // status success
          setMessageMovements(translate("dashboard.accounting.message.NO_TRANSACTION"));
        } else if (response?.code === 416) {
          setLoadingDoors((prevLoadingDoors) => ({ ...prevLoadingDoors, [id]: 1 })); // status success
          setMessageMovements(translate("dashboard.accounting.message.MAX_DATE_INTERVAL"));
        } else {
          setLoadingDoors((prevLoadingDoors) => ({ ...prevLoadingDoors, [id]: 2 })); // status error
          setMessageMovements(translate("dashboard.packages.details.dropOff.receivePackage.NOT_FOUND"));
        }

        setModuleShowed(moduleShowedRef.current);
        setActionsInProgress((prev) => prev - 1);
      };

      handleResponse();
    } catch (error) {
      setLoadingDoors((prevLoadingDoors) => ({ ...prevLoadingDoors, [id]: 2 })); // status error
      console.error("Error action-" + action + " door", error);
      setActionsInProgress((prev) => prev - 1);
    }
  };

  const handleOptionSelection = (action) => {
    if (action === "movements") {
      setActiveSearch(true);
      handleActionDoors(selectedDoor[0], action);
    }
    if (action !== "movements") setDateInputIsActive(false);
      if (selectedDoor?.length > 0) {
        setBtnActionIsActive(false);
        selectedDoor.forEach((door) => {
          handleActionDoors(door, action);
        });
      }
  };

  const handleGetDoors = async (signal) => {
    let response = [];
    
    try {
      // Primero intentar con externalId (idPlatform)
      response = await getDoorsByPlatform(idPlatform, signal);
    } catch (error) {
      // Si falla la primera llamada, continuar al segundo intento
      console.error('Error al obtener puertas con externalId:', error);
      response = [];
    }
    
    // Si no hay resultados y tenemos idPlatformNumeric, intentar con ese
    if ((!response || response.length === 0) && idPlatformNumeric) {
      try {
        response = await getDoorsByPlatform(idPlatformNumeric, signal);
      } catch (error) {
        // Si también falla el segundo intento, mantener array vacío
        console.error('Error al obtener puertas con platformId:', error);
        response = [];
      }
    }
    
    if (signal?.aborted) return;
    const grouped = await groupDoors(response || []);
    setDoors(grouped);
  };

  // Cargar asignaciones de empresas
  const loadDoorAssignments = async (signal) => {
    if (idPlatformNumeric) {
      try {
        const assignments = await getDoorCompanyAssignments(idPlatformNumeric, signal);
        const assignmentMap = {};
        assignments.forEach(assignment => {
          assignmentMap[assignment.doorId] = {
            companyCode: assignment.companyCode,
            companyName: assignment.companyName
          };
        });
        setDoorAssignments(assignmentMap);
      } catch (error) {
        console.error('Error loading door assignments:', error);
      }
    }
  };

const groupDoors = async (doorArray) => {
    if (doorArray?.length === 0) return [];
    const groupedDoors = {};
    doorArray?.forEach(door => {
        const key = `${door.boxitDoorId}`;
        if (!groupedDoors[key]) {
            groupedDoors[key] = {
                locationId: door.locationId,
                moduleId: door.moduleId,
                boxitLocationId: door.boxitLocationId,
                boxitModuleId: door.boxitModuleId,
                boxitDoorId: door.boxitDoorId,
                doorNumber: door.doorNumber,
                dimension: door.dimension,
                comPort: door.comPort,
                createdAt: door.createdAt,
                doorSequence: door.doorSequence,
                isActive: door.isActive,
                isAvailable: door.isAvailable,
                isScreen: door.isScreen,
                columnModule: door.columnModule,
                layer: door.layer,
                packageStatusId: door.packageStatusId,
                moduleNumber: Number(door.moduleNumber),
                packages: []
            };
        }
        if (groupedDoors[key].packages.length > 0 || door.packageId) {
            groupedDoors[key].packages.push({
                packageId: door.packageId,
                packageNumber: door.packageNumber,
            });
        }
    });

    const groupedDoorsArray = Object.values(groupedDoors);

    // Mismo orden que la configuración: por moduleNumber y luego por doorSequence (posición en la columna)
    return groupedDoorsArray.sort(compareDoorPosition);
};

  const setDefaultDates = () => {
    const today = formatDate(todayDate);
    const firstDateOfMonth = formatDate(firstDayOfMonth);
    setDefaultFromDate(firstDateOfMonth);
    setDefaultToDate(today);
  };

  const resetFilters = () => {
    setLoadingDoors({});
    setSelectedDoor([]);
    setListMovements(null)
    setMessageMovements("");
    setActionSelect(null);
    // setActiveSearch(false);
    setDateInputIsActive(false);
    setModuleShowed(moduleShowedRef.current);
  };

  useEffect(() => {
    /* The controller belongs to the mount, not to the render. It used to be
       built in the component body, so every render made a new one while this
       cleanup kept the first. Under React 18's StrictMode — which mounts,
       unmounts and remounts every effect in development — the cleanup aborted
       the very controller the re-run effect then fetched with: both attempts
       threw, both were caught as "no doors", and the locker view rendered
       NOT AVAILABLE on every visit to the dev server. */
    const controller = new AbortController();
    setDefaultDates();
    handleGetDoors(controller.signal);
    loadDoorAssignments(controller.signal);
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (doors?.length > 0) {
      const mods = calculateModuleQuantity(doors);

      const modDoors = doors.filter((door) => door?.boxitModuleId === mods[moduleShowedRef.current]);
      setModules(mods);
      setModuleShowed(moduleShowedRef.current || 0);

      handleDoorsChange(modDoors);
    }
  }, [doors]);


  useEffect(() => {
    handleGetDoors();

    if (actionSelect === "movements") {
      // setActiveSearch(false);
    } else if (actionsInProgress === 0) {
      const timeoutId = setTimeout(() => {
        resetFilters();
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionsInProgress]);

  return (
    <>
      <ToastContainer toasts={toasts} removeToast={removeToast} />
      {doors ? (
        doors.length > 0 ? (
          <div className="locker">
            {/* Actions Buttons */}
            <div className="mb-2 locker-actions" role="group">{buttonsActions}</div>

          
            {/* Modules Pagination */}
             {modules?.length > 1 ? (
              /* Two bare 50px carets, coloured white, sitting loose in the
                 middle of the panel. They read as glyphs rather than controls
                 and vanished in light mode. Now proper circular buttons with a
                 hit area, a hover state and a disabled state that is a real
                 `disabled` rather than an opacity you can still click. */
              <div className="mt-md-3 mb-2 flex items-center justify-center gap-4 p-1">
                <button
                  type="button"
                  aria-label={translate("global.previousModule")}
                  disabled={!btnsNavigator.back}
                  onClick={() => btnsNavigator.back && handleModuleChange(0)}
                  className="module-nav-btn"
                >
                  <FaCaretLeft size={22} />
                </button>

                <span className="min-w-[7.5rem] text-center text-sm font-medium tracking-tight">
                  {translate("global.module")} {moduleShowed + 1}
                </span>

                <button
                  type="button"
                  aria-label={translate("global.nextModule")}
                  disabled={!btnsNavigator.next}
                  onClick={() => btnsNavigator.next && handleModuleChange(1)}
                  className="module-nav-btn"
                >
                  <FaCaretRight size={22} />
                </button>
              </div>
            ) : (
              <div className="mt-md-3 mb-2"></div>
            )}
            {/* Doors Module */}
         
           <div className="section-smart-locker doorsContainer">
              {column1.length > 0 && <div style={styles.doorsColumn}>{renderDoors(column1)}</div>}
              {column2.length > 0 && <div style={styles.doorsColumn}>{renderDoors(column2)}</div>}
            </div>
             
             {/* Selected Doors */}
             {selectedDoor?.length > 0 &&
              <div className="mb-2" style={styles.selectedDoor}>{modalCustome}</div>
            }

            <div className="mt-md-3 locker-legend">{legends}</div>

          </div>
        ) :
          <div className="p-6 flex justify-center" style={{ fontSize: 14 }} >
            <LuAlertCircle size={20} className="mr-2" />{" "}
            {translate("global.NOT_AVAILABLE")}
          </div>
      ) : (
        <div className="loader center">
          <Spinner type={0} size={40} />
        </div>
      )}
    </>
  );
};

const styles = {
  colorsProperties: {
    occupied: "#ea580c",
    reserved: "#3AA0E8",
    available: "#61D565",
    inactive: "#393939",
    expired: "#CFCFCF",
    actived: "#E5BA00",
  },
  doorsColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    flex: 1,
    minWidth: 0,
    gap: 8,
  },
  door: {
    padding: "1px",
    width: "100%",
    borderRadius: "px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  doorHover: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  doorStatus: {
    padding: "5px 10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "100%",
    borderRadius: "10px",
  },
  legendActions: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 10,
    maxWidth: "100%",
  },
  legend: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 10,
    maxWidth: "100%",
  },
  itemLegends: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    border: "1px solid",
    padding: "7px 12px",
    borderRadius: "999px",
    color: "hsl(var(--foreground))",
    fontSize: "12px",
    background: "hsl(var(--foreground) / 0.04)",
    transition: "background-color 160ms ease",
    circle: {
      height: "10px",
      width: "10px",
      borderRadius: "50%",
      backgroundColor: "red",
      boxShadow: "0 0 0 3px hsl(var(--foreground) / 0.06)",
    },
  },
  itemButtons: {
    display: "inline-flex",
    alignItems: "center",
    padding: "9px 16px",
    background: "hsl(var(--foreground) / 0.08)",
    border: "1px solid hsl(var(--foreground) / 0.12)",
    borderRadius: "10px",
    color: "hsl(var(--foreground))",
    fontSize: "13px",
    fontWeight: 500,
    letterSpacing: "0.01em",
    transition: "background-color 160ms ease, border-color 160ms ease, transform 160ms ease",
    isActive: {
      border: "2px solid hsl(var(--primary))",
    },
  },
  selectedDoor: {
    // position:"absolute",
    top: "100px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    background: "hsl(var(--foreground) / 0.06)",
    border: "1px solid hsl(var(--foreground) / 0.10)",
    gap: 10,
    marginTop: "15px",
    padding: "12px",
    width: "90%",
    borderRadius: "12px",
    color: "hsl(var(--foreground))",
  },
  doorSelected: {
    display: "flex",
    alignItems: "center",
    padding: "4px 9px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "12px",
    transition: "background-color 160ms ease",
    backgroundColor: "hsl(var(--foreground) / 0.10)",
  },
  openDoor: {
    transition: "transform 0.5s ease-in-out",
    transform: "rotateY(90deg)",
  },
  inputDate: {
    width: "100px",
    background: "transparent",
    border: "1px solid gray",
    padding: "5px",
    color: "#adadad",
    borderRadius: "8px",
  },
};

export default SmartLocker;
